import { protectedResources } from '../../authConfig';
import makeGetRequestAsync, { makePUTRequestAsync } from '../Helpers/httpRequestHelpers';
import { CompanyRegistrationMessage } from './Models/companyRegistrationMessage';
import { UpsertCompanyRegistrationMessage } from './Models/upsertCompanyRegistrationMessage';

const apiScopes = protectedResources.companyApi.scopes;
const baseUrl = protectedResources.companyApi.endpoint;

/*
 * Retrieves the company registration status
 */
export const GetCompanyRegistrationStatus = async () => {
  const url = `${baseUrl}/api/Company/CompanyRegistration`;
  const result = await makeGetRequestAsync<CompanyRegistrationMessage>(apiScopes, url);
  return result.data;
};

/*
 * Update or create the company registration status
 */
export const CreateOrUpdateCompanyRegistrationStatus = async (
  message: UpsertCompanyRegistrationMessage
) => {
  const url = `${baseUrl}/api/Company/CompanyRegistration`;
  const result = await makePUTRequestAsync<void, UpsertCompanyRegistrationMessage>(
    apiScopes,
    url,
    message
  );
  return result.data;
};
